import React from 'react';

const CharBlank = (props) => (
    <div 
        key={props.index} 
        id={props.label} 
        className={"char-blank"}
    ></div>
);

export default CharBlank;



// WEBPACK FOOTER //
// ./src/components/sections/shared/CharBlank.js